import React, { useEffect, useState, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";

// Hooks
import { OuterClick } from "react-outer-click";

// External components
import SVG from "react-inlinesvg";
import KeyboardEventHandler from "react-keyboard-event-handler";

// Internal components
import LanguagePicker from "components/LanguagePicker";
import Meta from "components/Meta";

// Contexts
import { DataContext } from "contexts/Data";

const Broderier = () => {
    const { data, language, screenWidth, setLanguage } =
        useContext(DataContext);
    const { pathname } = useLocation();
    const [current, setCurrent] = useState("");
    const [showModal, setShowModal] = useState(false);
    const btnRef = useRef();
    // useEffect(() => {
    //     if (showModal) {
    //         document.body.classList.add("noscroll");
    //     } else {
    //         document.body.classList.remove("noscroll");
    //     }
    // }, [showModal]);
    useEffect(() => {
        if (pathname === "/broderier" || pathname === "/embroideries") {
            document.body.classList.add("body--broderier");
            document.getElementById("root").style.overflowX = "visible";
        } else {
            document.body.classList.remove("body--broderier");
            document.getElementById("root").style.overflowX = "hidden";
        }
        if (pathname === "/embroideries") {
            setLanguage("en");
            setTimeout(() => {
                setScaleBy(scaleBy + 0.01);
            }, 1);
        } else if (pathname === "/broderier") {
            setLanguage("no");
        }
    }, [pathname]);

    useEffect(() => {
        // CREATE ELEMENTS
        for (let i = 0; i < 36; i++) {
            const div = document.createElement("div");
            const container = document.createElement("div");
            const frame = document.createElement("div");
            const img = document.createElement("img");
            const button = document.createElement("div");
            button.classList.add("item__button");
            img.setAttribute(
                "src",
                process.env.PUBLIC_URL + `/images/broderier/sm/${i}.jpg`
            );
            button.ref = btnRef;
            div.classList.add("item");
            div.setAttribute("data-index", i);
            frame.classList.add("item__frame");
            container.classList.add("item__container");
            img.classList.add("item__img");
            container.appendChild(img);
            container.appendChild(button);
            div.appendChild(container);
            div.appendChild(frame);
            document.querySelector(".wrapper").appendChild(div);
        }
    }, []);
    useEffect(() => {
        const selectThis = (e) => {
            let target = e.target;
            let parent = target.parentElement;
            let img = parent.querySelector("img").getAttribute("src");
            let item = parent.parentElement;
            let itemIndex = parseInt(item.getAttribute("data-index")) - 1;
            let description = data.broderier[itemIndex].description;
            let title = data.broderier[itemIndex].title;
            let author = data.broderier[itemIndex].author;

            // FOR HIGH RES IMAGES
            // setCurrent({ img: img.replace("sm", "lg") });

            setCurrent({
                img: img,
                description: description ? description[language] : "",
                title: title ? title[language] : "",
                author: author ? author : "",
            });
            setShowModal(true);
        };

        document.querySelectorAll(".item__button").forEach((el) => {
            const delta = 6;
            let startX;
            let startY;
            el.addEventListener("mousedown", function (event) {
                startX = event.pageX;
                startY = event.pageY;
            });

            el.addEventListener("mouseup", function (event) {
                const diffX = Math.abs(event.pageX - startX);
                const diffY = Math.abs(event.pageY - startY);

                if (diffX < delta && diffY < delta) {
                    selectThis(event);
                }
            });
        });
    }, [language, data.broderier]);
    // useEffect(() => {
    //     document.querySelectorAll(".item__button").forEach(
    //         (el) =>
    //             (el.innerHTML = `${language === "no" ? "Åpne" : ""}
    //             ${language === "en" ? "Open" : ""}`)
    //     );
    // }, [language]);
    useEffect(() => {
        const wrapper = document.querySelector(".wrapper");
        const frameRate = 2;
        const minScale = 0.5;
        const maxScale = 1;
        const scaleRange = maxScale - minScale;
        let lastFrame;

        // this helper function stolen from a hero on stackoverflow
        function dynamicSort(property) {
            let sortOrder = 1;

            if (property[0] === "-") {
                sortOrder = -1;
                property = property.substr(1);
            }

            return function (a, b) {
                let result =
                    a[property] < b[property]
                        ? -1
                        : a[property] > b[property]
                        ? 1
                        : 0;
                return result * sortOrder;
            };
        }

        function animateChildren(parent, origin) {
            if (!showModal) {
                const children = Array.from(parent.children);
                const childrenWithDistances = [];

                children.forEach((child) => {
                    const r = child.getBoundingClientRect();
                    const childX = r.right - r.width / 2;
                    const childY = r.bottom - r.height / 2;
                    const distanceY =
                        Math.max(origin.y, childY) - Math.min(origin.y, childY);
                    const distanceX =
                        Math.max(origin.x, childX) - Math.min(origin.x, childX);
                    const hypot = Math.hypot(distanceX, distanceY);

                    child.distance = Math.round(hypot);
                    childrenWithDistances.push(child);
                });

                childrenWithDistances.sort(dynamicSort("distance")).reverse();

                childrenWithDistances.forEach((child, index) => {
                    const relativeAmt = (index / children.length) * scaleRange;
                    child.style.setProperty("--scale", minScale + relativeAmt);
                });
            }
        }
        const onMoveMouse = (e) => {
            if (!showModal) {
                requestAnimationFrame(function (thisFrame) {
                    if (thisFrame - lastFrame > frameRate) {
                        const screenCenter = {
                            x: window.innerWidth / 2,
                            y: window.innerHeight / 2,
                        };
                        const moveX = e.x - screenCenter.x;
                        const moveY = e.y - screenCenter.y;

                        wrapper.style.setProperty("--x", moveX / 10 + "%");
                        wrapper.style.setProperty("--y", moveY / 10 + "%");

                        animateChildren(wrapper, e);
                    }

                    lastFrame = thisFrame;
                });
            }
        };
        const onScroll = (e) => {
            if (!showModal) {
                const screenCenter = {
                    x: window.innerWidth / 2,
                    y: window.innerHeight / 2,
                };

                animateChildren(wrapper, screenCenter);
            }
        };
        if (window.screen.width > 1000) {
            wrapper.addEventListener("mousemove", onMoveMouse);
            wrapper.addEventListener("scroll", onScroll);
        } else {
            document.addEventListener("mousemove", onMoveMouse);
            document.body.addEventListener("scroll", onScroll);
        }
    }, []);
    const originalWidth = window.innerWidth;
    window.onorientationchange = function () {
        var orientation = window.orientation;
        switch (orientation) {
            case 0:
            case 90:
            case -90:
                window.location.reload();
                break;
        }
    };

    if (
        !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        )
    ) {
        window.addEventListener(
            "resize",
            () =>
                ((originalWidth > 900 && window.innerWidth < 900) ||
                    (originalWidth < 900 && window.innerWidth < 900)) &&
                window.location.reload()
        );
    }
    useEffect(() => {
        var scale = 1,
            panning = false,
            pointX = 0,
            pointY = 0,
            start = {
                x: 0,
                y: 0,
            },
            zoom = document.getElementById("zoom");
        if (!showModal) {
            function setTransform() {
                zoom.style.transform =
                    "translate(" +
                    pointX +
                    "px, " +
                    pointY +
                    "px) scale(" +
                    scale +
                    ")";
            }

            zoom.onmousedown = function (e) {
                e.preventDefault();
                start = { x: e.clientX - pointX, y: e.clientY - pointY };
                panning = true;
            };

            zoom.onmouseup = function (e) {
                panning = false;
            };

            zoom.onmousemove = function (e) {
                e.preventDefault();
                if (!panning) {
                    return;
                }
                pointX = e.clientX - start.x;
                pointY = e.clientY - start.y;
                setTransform();
            };

            document.addEventListener("gesturestart", function (e) {
                e.preventDefault();
            });

            document.addEventListener("gesturechange", function (e) {
                e.preventDefault();
                if (!showModal) {
                    zoom.style.transform =
                        "translate(" +
                        pointX +
                        "px, " +
                        pointY +
                        "px) scale(" +
                        scale +
                        ")";
                }
            });

            document.addEventListener("gestureend", function (e) {
                e.preventDefault();
            });
            zoom.ondblclick = function (e) {
                e.preventDefault();
                var xs = (e.clientX - pointX) / scale,
                    ys = (e.clientY - pointY) / scale;
                scale *= 2;
                pointX = e.clientX - xs * scale;
                pointY = e.clientY - ys * scale;
                zoom.style.transition =
                    "transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1)";
                console.log(pointX, pointY);
                setTransform();
            };
            zoom.onwheel = function (e) {
                zoom.style.transition =
                    "transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1)";
                e.preventDefault();

                if (screenWidth < 900) {
                    scale += e.deltaY * -0.01;

                    // Restrict scale
                    scale = Math.min(Math.max(0.125, scale), 4);

                    // Apply scale transform
                    setScaleBy(scale);
                } else {
                    var xs = (e.clientX - pointX) / scale,
                        ys = (e.clientY - pointY) / scale,
                        delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
                    delta > 0 ? (scale *= 1.03) : (scale /= 1.03);
                    pointX = e.clientX - xs * scale;
                    pointY = e.clientY - ys * scale;
                    setTransform();
                }
                // setZoomData({
                //     clientX: e.clientX,
                //     pointX: pointX,
                //     scale: scale,
                //     clientY: e.clientY,
                // });
            };
        } else if (showModal) {
            zoom.onmousedown = null;
            zoom.onmouseup = null;
            zoom.onmousemove = null;
            document.addEventListener("gesturestart", null);
            document.addEventListener("gesturechange", null);
            document.removeEventListener("gestureend", null);
            zoom.ondblclick = null;
            zoom.onwheel = null;
        }
    }, [screenWidth, showModal]);
    const [scaleBy, setScaleBy] = useState(1);

    useEffect(() => {
        if (screenWidth < 900) {
            let wrapW = document.querySelector(".wrapper").scrollWidth / 2;
            let wrapH = document.querySelector(".wrapper").scrollHeight / 2;
            document.body.scrollTo(wrapW, wrapH);
            if (scaleBy) {
                let wrap = document.querySelector(".wrapper");
                wrap.style.transform = `scale(${scaleBy})`;
            }
        }
    }, [screenWidth, scaleBy]);
    useEffect(() => {
        let langPicker = document.querySelector(".language-picker");
        if (showModal) {
            let modalWrapper = document.querySelector(".broderier-modal");
            let modalBox = document.querySelector(".broderier-modal__box");
            modalWrapper.addEventListener("wheel", (e) => {
                e.stopPropagation();
                if (e.target === modalWrapper) {
                    modalBox.scrollTo(0, modalBox.scrollTop + e.deltaY);
                }
            });
            langPicker.classList.add("language-picker--modal-open");
        } else {
            langPicker.classList.remove("language-picker--modal-open");
        }
    }, [showModal]);
    useEffect(() => {
        if (!showModal) {
            document.getElementById("broderier-modal-scroller").scrollTop = 0;
        }
    }, [showModal]);
    // const [ios, setIos] = useState(null);
    useEffect(() => {
        if (
            screenWidth < 900 &&
            window.matchMedia("(pointer: coarse)").matches
        ) {
            let z = document.querySelector(".wrapper");
            document.addEventListener("gesturestart", function (e) {
                e.preventDefault();
                // special hack to prevent zoom-to-tabs gesture in safari d
                document.querySelector(".wrapper").style.transition =
                    "transition: none;";
            });
            document.addEventListener("gesturechange", function (e) {
                e.preventDefault();
                z.style.transform = `scale(${parseFloat(e.scale).toFixed(4)}
                ) rotate(${e.rotation}deg)`;
                // z.style.transform = `scale(${e.scale}) rotate(${
                //     e.rotation
                // }deg)`;
                // transform: translate(-872.156px, -892.992px) scale(2.48832);
                // console.log(e);
                // setScaleBy(e.scale);
                // setIos({
                //     clientX: e.clientX,
                //     clientY: e.clientY,
                //     screenX: e.screenX,
                //     screenY: e.screenY,
                // });
                // special hack to prevent zoom-to-tabs gesture in safari
            });

            document.addEventListener("gestureend", function (e) {
                e.preventDefault();
                // special hack to prevent zoom-to-tabs gesture in safari
                // document.body.style.zoom = 0.99;
            });
        }
    }, [screenWidth]);
    // const [modalScrolled, setModalScrolled] = useState(0);
    // useEffect(() => {
    //     let modalBox = document.getElementById("broderier-modal-scroller");
    //     modalBox.addEventListener("scroll", (e) => {
    //         if (modalBox.scrollTop <= e.target.clientHeight) {
    //             setModalScrolled(modalBox.scrollTop);
    //         } else {
    //         }
    //     });
    // }, []);
    // useEffect(() => {
    //     let modalImg = document.getElementById("broderier-modal-img");
    //     if (screenWidth > 1600 && modalImg !== null) {
    //         modalImg.style.transform = `translateY(${modalScrolled}px)`;
    //     }
    // }, [screenWidth, modalScrolled]);

    return (
        <>
            <KeyboardEventHandler
                handleKeys={["esc"]}
                onKeyEvent={(key, e) => setShowModal(false)}
            />
            {/* <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    zIndex: 9999,
                    background: "black",
                }}
            >
                <pre>{JSON.stringify(zoomData, null, 1)}</pre>
            </div>
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    zIndex: 9999,
                    background: "black",
                }}
            >
                <pre>{JSON.stringify(ios, null, 1)}</pre>
            </div> */}
            <div className="zoom-controls">
                <div class="zoom-controls__wrapper">
                    <div
                        class="zoom-controls__btn"
                        onClick={(e) => {
                            setScaleBy(scaleBy + 0.5);
                            document.querySelector(
                                ".wrapper"
                            ).style.transition =
                                "all 1.3s cubic-bezier(0.165, 0.84, 0.44, 1)";
                        }}
                    >
                        +
                    </div>
                    <div
                        class="zoom-controls__btn"
                        onClick={(e) => {
                            if (scaleBy > 0.2) {
                                setScaleBy(scaleBy - 0.5);
                            }
                            document.querySelector(
                                ".wrapper"
                            ).style.transition =
                                "all 1.3s cubic-bezier(0.165, 0.84, 0.44, 1)";
                        }}
                    >
                        -
                    </div>
                </div>
            </div>
            <Meta
                title={data.seo.broderier.title[language]}
                description={data.seo.broderier.description || ""}
                image={data.seo.broderier.image || ""}
            />
            <LanguagePicker
                modifier="broderier"
                redirects={{
                    no: data.pages.broderier.to.no,
                    en: data.pages.broderier.to.en,
                }}
            />
            <div
                // onClick={() => setShowModal(false)}
                className={`broderier-modal ${
                    showModal
                        ? "broderier-modal--show"
                        : "broderier-modal--hidden"
                }`}
            >
                <OuterClick onOuterClick={() => setShowModal(false)}>
                    <div
                        className="broderier-modal__box"
                        id="broderier-modal-scroller"
                    >
                        <button
                            className="broderier-modal__close"
                            onClick={() => setShowModal(false)}
                        >
                            <SVG
                                src={
                                    process.env.PUBLIC_URL + "/images/close.svg"
                                }
                            />
                        </button>
                        <div
                            className={`broderier-modal__content ${
                                current.title
                                    ? ""
                                    : "broderier-modal__content--no-title"
                            }`}
                        >
                            {current.img && (
                                <div
                                    className="broderier-modal__img-wrapper"
                                    id="broderier-modal-img"
                                >
                                    <img
                                        className="broderier-modal__img-wrapper__frame"
                                        alt="broderi-frame"
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/images/frame.png"
                                        }
                                    />
                                    <img
                                        className="broderier-modal__img-wrapper__img"
                                        alt="broderi-current"
                                        src={current.img}
                                    />
                                </div>
                            )}
                            <div className="broderier__text">
                                {current.title && (
                                    <h1 className="broderier__text__title">
                                        «{current.title}»
                                    </h1>
                                )}
                                {current.author && (
                                    <h2 className="broderier__text__author">
                                        <span>
                                            {language === "en" ? "by" : ""}
                                            {language === "no"
                                                ? "av"
                                                : ""}: {current.author}
                                        </span>
                                    </h2>
                                )}
                                {current.description && (
                                    <div
                                        className="broderier__text__description broderier__text__description--landscape-hidden"
                                        dangerouslySetInnerHTML={{
                                            __html: current.description,
                                        }}
                                    ></div>
                                )}
                            </div>
                            {current.description && (
                                <div
                                    className="broderier__text__description broderier__text__description--landscape-only"
                                    dangerouslySetInnerHTML={{
                                        __html: current.description,
                                    }}
                                ></div>
                            )}
                        </div>
                    </div>
                </OuterClick>
            </div>
            <div className="zoom-mobile">
                <div
                    className={`zoom_outer ${
                        showModal ? "zoom_outer--modal-open" : ""
                    }`}
                >
                    <div id="zoom">
                        <div className="wrapper-position">
                            <div className="wrapper"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Broderier;
